import { create } from 'zustand';

type UpdateBannerState = {
  isDismissed: boolean;
  dismiss: () => void;
  reset: () => void;
};

/**
 * Per-session dismiss state shared between UpdateReadyBanner (Account screen)
 * and the Account-tab badge. Tapping X on the banner sets isDismissed; both
 * surfaces hide for the rest of the session. Reset when isUpdatePending flips
 * false so a freshly-pending bundle can re-show the banner and badge.
 */
export const useUpdateBannerStore = create<UpdateBannerState>((set) => ({
  isDismissed: false,
  dismiss: () => set({ isDismissed: true }),
  reset: () => set({ isDismissed: false }),
}));
